import Skeleton from "@mui/material/Skeleton";

function AppSkeleton({
  height,
  width,
  baseColor = "",
  highlightColor,
  variant = "text",
  className,
}) {
  const theme = window.sessionStorage.getItem("theme");
  let themeBaseColor = "#1b2047";
  let themeHighlightColor = "#040721";
  if (theme) {
    themeBaseColor = theme === "light" ? "#dadada" : "#252525";
    themeHighlightColor = theme === "light" ? "#ffffff" : "#646464";
  }

  const appBaseColor = baseColor || themeBaseColor;
  const appHighlightColor = highlightColor || themeHighlightColor;

  return (
    <Skeleton
      className={className}
      height={height}
      width={width}
      animation="wave"
      variant={variant}
      sx={
        appBaseColor
          ? {
              bgcolor: appBaseColor,
              "&::after": {
                background: `linear-gradient( 90deg, ${appBaseColor} , ${appHighlightColor},${appBaseColor} )`,
              },
            }
          : {}
      }
    />
  );
}

export default AppSkeleton;
